import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Loader reutilizable con texto de progreso.
 * Estilo: spinner circular con arco primario y texto centrado debajo.
 *
 * @example
 * <app-loader-with-text message="Cargando datos..." />
 * <app-loader-with-text message="Guardando pauta..." size="lg" />
 */
@Component({
  selector: 'app-loader-with-text',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col items-center gap-4">
      <div
        class="loader-with-text-spinner rounded-full border-[3px] animate-spin"
        [ngClass]="'size-' + size()"
      ></div>
      @if (message()) {
        <span class="text-sm font-medium text-gray-600 dark:text-gray-400 text-center">
          {{ message() }}
        </span>
      }
    </div>
  `,
  styles: [`
    .loader-with-text-spinner {
      border-color: rgb(229 231 235);
      border-top-color: var(--p-primary-color, #3b82f6);
    }

    .dark .loader-with-text-spinner {
      border-color: rgb(55 65 81);
      border-top-color: var(--p-primary-color, #60a5fa);
    }

    .loader-with-text-spinner.size-sm {
      width: 24px;
      height: 24px;
    }

    .loader-with-text-spinner.size-md {
      width: 32px;
      height: 32px;
    }

    .loader-with-text-spinner.size-lg {
      width: 40px;
      height: 40px;
    }
  `]
})
export class LoaderWithTextComponent {
  /** Mensaje a mostrar debajo del spinner */
  message = input<string>('');

  /** Tamaño del spinner: sm (24px), md (32px), lg (40px) */
  size = input<'sm' | 'md' | 'lg'>('md');
}
